import CustomStore from "devextreme/data/custom_store";
import { getLoadOptionsParams } from "../../utils/loadOptionsParams";
import axios from "axios";

const remoteDataSource = (additionalFilter) => {
  return new CustomStore({
    key: "id",
    load: async (loadOptions) => {
      return await axios
        .get(`/api/users/get` + getLoadOptionsParams(loadOptions), {
          params: additionalFilter,
        })
        .then((response) => {
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary,
          };
        })
        .catch((error) => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
  });
};

const createCardViewDataSource = (filter) => {
  var urlParams = new URLSearchParams(window.location.search);
  return new CustomStore({
    key: "id",
    load: async (loadOptions) => {
      return await axios
        .get(`/api/scheme/get` + getLoadOptionsParams(loadOptions), {
          params: {
            schemeId: filter.parentSchemeId,
            timeScope: filter.timeScope,
            translateCalls: filter.translateScheme,
            terms: urlParams.get("t")
          },
        })
        .then((response) => {
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary,
          };
        })
        .catch((error) => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
  });
};

export { createCardViewDataSource, remoteDataSource };
